<template>
    <div>
        <Exception type="403" img-color :desc="$t('page.exception.e403')" :back-text="$t('page.exception.btn')" />
    </div>
</template>
<script>
    export default {
        name:'plat-error403',
    }
</script>



// WEBPACK FOOTER //
// src/pages/error/403/index.vue